import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-46645ec4"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrapper" };
var _hoisted_2 = { class: "artical" };
var _hoisted_3 = { class: "artical-title" };
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "artical-author" }, "量觉科技", -1); });
var _hoisted_5 = { class: "artical-date" };
var _hoisted_6 = { class: "artical-content" };
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = { class: "time" };
var _hoisted_9 = { class: "overlay-wrapper" };
import { ref } from "vue";
import { Toast } from "vant";
import { requestArticalDetail } from "@/api";
export default /*#__PURE__*/ _defineComponent({
    __name: 'artical',
    props: {
        articalId: {
            required: true,
            type: Number,
        },
    },
    emits: ["cancel"],
    setup: function (__props, _a) {
        var _this = this;
        var emit = _a.emit;
        var props = __props;
        var loading = ref(true);
        var articalData = ref({});
        var getProductsList = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestArticalDetail(props.articalId).catch(function () {
                            loading.value = false;
                            Toast("系统错误-02");
                        })];
                    case 1:
                        res = _a.sent();
                        loading.value = false;
                        if (res.code === 200) {
                            articalData.value = res.data;
                        }
                        else {
                            Toast(res.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        getProductsList();
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: articalData.value.articleType === 1 ? '肿瘤领域' : '感染领域',
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (emit('cancel')); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }, 8, ["title"]),
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(articalData.value.articleTitle), 1),
                    _hoisted_4,
                    _createElementVNode("p", _hoisted_5, _toDisplayString(articalData.value.releaseTime), 1),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                            innerHTML: articalData.value.articleContent
                        }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("p", _hoisted_8, [
                        _createElementVNode("span", null, "阅读量 " + _toDisplayString(articalData.value.readingQuantity >= 10000
                            ? parseInt(String(articalData.value.readingQuantity / 10000)) + "\u4E07+"
                            : articalData.value.readingQuantity), 1)
                    ])
                ], 512), [
                    [_vShow, !loading.value]
                ]),
                _createVNode(_component_van_overlay, {
                    show: loading.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ]));
        };
    }
});
